import type { ControlledSource } from "./filth-source-control-api"

import { api } from "@/lib/api-client"

export type FilthSourceJob = {
  job_id: string
  status: string
  phase: string | null
  created_at: number | null
  started_at: number | null
  finished_at: number | null
  entities_done: number | null
  entities_total: number | null
  error_code: string | null
}

export type FilthSource = Omit<Partial<ControlledSource>, "target"> & {
  control_target?: ControlledSource["target"]
  connector_uid: string
  kind: string
  enabled: boolean
  interval_seconds: number | null
  target: string
  latest_job: FilthSourceJob | null
}

export type FilthSources = { connectors: FilthSource[]; next?: string | null }

export async function getFilthSources(id: string, cursor?: string): Promise<FilthSources> {
  const response = await api.get(`/admin/filth-backends/${encodeURIComponent(id)}/sources`, {
    params: cursor ? { cursor } : {},
  })
  return (response.data || response) as FilthSources
}
